module.exports = require('./../dist/svg-components/nerdwallet-ui/FeedbackSuccess');